import { toHumanReadableDate } from '@shared/services/dateService';
import { OBSERVATION_REPORT_RESULT_MAP } from '../../observationReport/constants';

const AppraisserObservationReportMapper = {
  toTableData: reports =>
    reports.map(report => ({
      id: report.Id,
      orgUnitNames: report.Event?.OrgUnitNames,
      eventEndDate: toHumanReadableDate(report.Event?.EndDate),
      observeeRole: report.ObservedUser?.SystemRole?.DisplayName,
      observeeId: report.ObservedUser?.Id,
      observerName: report.ObserverUser?.FullName,
      status: OBSERVATION_REPORT_RESULT_MAP.get(report.Result),
      fileName: report.Document?.FileName,
      eventId: report.EventId
    }))
};

export default AppraisserObservationReportMapper;
